var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 14,
    viewBox: "0 0 60 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.453 13.8468L6.0895 7.75732L4.07259 9.54151V13.8468H0V0H4.07259V5.27498L9.77423 0H14.5838L8.86274 5.25559L15.1074 13.8468H10.453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.697 13.8468L24.6498 11.2675H18.2694L17.2416 13.8468H13.1108L19.1421 0H23.9129L29.9442 13.8468H25.697ZM21.4693 3.21929L19.4718 8.18397H23.4668L21.4693 3.21929Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1973 13.8468L33.1769 5.43013V13.8468H29.2983V0H32.9054L39.9258 8.4167V0H43.8045V13.8468H40.1973Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7529 13.8468L54.7056 11.2675H48.3252L47.2974 13.8468H43.1666L49.1979 0H53.9687L60 13.8468H55.7529ZM51.5251 3.21929L49.5276 8.18397H53.5226L51.5251 3.21929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanaLight);
export default __webpack_public_path__ + "static/media/kana-light.da7552ca9eb3bad91947c9cfe5e7aec1.svg";
export { ForwardRef as ReactComponent };